var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('img',{attrs:{"src":"/logo.png"},on:{"click":function($event){return _vm.openlink('https://kiminjae.me')}}}),_c('span',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }